(ns dre.pages.frontpage.topic-search.templates.efficacy-safety
  (:require
   [dre.i18n.views :refer [tr]]))

(def template 
  {:efficacy-safety {:title [tr "Efficacy/Safety"]
                     :form-sub-heading [:<>
                                        [:span [tr "Please add one or more terms for any category."]]
                                        [:span [tr "After clicking “View Results”, you can edit your question and/or search criteria."]]]
                     :forms-type :common
                     :forms [{:title [tr "Populations"] 
                              :form-id :population
                              :form-type :common
                              :required? false
                              :top-terms-type ["C"]
                              :operator :and
                              :examples [{:pill/type :term
                                          :pill/query "SUFus"
                                          :pill/label "Acute Myeloid Leukemia"}
                                         {:pill/type :term
                                          :pill/query "SUBAB"
                                          :pill/label "Asthma"}
                                         {:pill/type :term
                                          :pill/query "SUElw"
                                          :pill/label "Heart Disease"}
                                         {:pill/type :term
                                          :pill/query "SUcB"
                                          :pill/label "Elderly"}]}
                             {:title [tr "Interventions/Comparators"] 
                              :form-id :intervention
                              :form-type :common
                              :required? false
                              :top-terms-type ["I"]
                              :operator :or
                              :examples [{:pill/type :senses
                                          :pill/query "SUyz"
                                          :pill/other-senses (list "SUBESP"),
                                          :pill/excluded-senses (list),
                                          :pill/label "Monoclonal Antibody"}
                                         {:pill/type :term
                                          :pill/query "SUClep"
                                          :pill/label "Gemtuzumab"}
                                         {:pill/type :term
                                          :pill/query "SUDspt"
                                          :pill/label "Mepolizumab"}
                                         {:pill/type :term
                                          :pill/query "SUDbK"
                                          :pill/label "Enalapril"}]}
                             {:title [tr "Outcomes"] 
                              :form-id :outcome
                              :form-type :common
                              :required? false
                              :top-terms-type ["O" "SYM"]
                              :operator :or
                              :examples [{:pill/type :term
                                          :pill/query "SUPlua"
                                          :pill/label "Overall Survival"}
                                         {:pill/type :term
                                          :pill/query "SUE4a"
                                          :pill/label "Hospitalization"}
                                         {:pill/type :term
                                          :pill/query "SUE-_S"
                                          :pill/label "Death"}
                                         {:pill/type :senses
                                          :pill/query "SUCTr"
                                          :pill/other-senses (list "SUOK3T","SUKU87"),
                                          :pill/excluded-senses (list),
                                          :pill/label "Infection"}]}] 
                     :review-query-render-fn (fn [items search-query-template]
                                               [:span.text (str " How does ") (:intervention items)
                                                " affect " (:outcome items) " in "
                                                (:population items)
                                                " population(s)?"])
                     :default-search-query-template :accuracy
                     :search-query-templates {:accuracy {:query/pill
                                                         {:pill/type "boost"
                                                          :pill/pills
                                                          [{:pill/type "and"
                                                            :pill/pills
                                                            [{:pill/type "tag"
                                                              :pill/query "predicted/safety_postfilter"
                                                              :pill/label "Efficacy/Safety"}
                                                             {:template-type :population
                                                              :pill/type "sentence-tag"
                                                              :pill/query "title-or-keywords"}
                                                             {:template-type :intervention
                                                              :pill/type "sentence-tag"
                                                              :pill/query "title-or-abstract-or-keywords"}
                                                             {:template-type :outcome}]}
                                                           {:template-type :population
                                                            :pill/type "sentence-tag"
                                                            :pill/query "title"}
                                                           {:template-type :intervention
                                                            :pill/type "sentence-tag"
                                                            :pill/query "title-or-keywords"}
                                                           {:template-type :outcome
                                                            :pill/type "sentence-tag"
                                                            :pill/query "title-or-abstract"}]}
                                                         :response/filter
                                                         {:search/count true :search/count-1w true :search/count-6m true}}}}})
